export default {
  dashboard: 'Dashboard',
  system_manage: 'System',
  simulation_manage: 'Mock CallBack',
  account_settings: 'Account Settings',
  simulation_payment: 'Bills Payment',
  simulation_dynamic_payment: 'Dynamic Payment',
  simulation_qr_payment: 'QR Code',
  simulation_bank_transfer_payment: 'Bank Transfer',
  simulation_payout: 'Disburse',
  simulation_checkout_payment: 'Simulate Checkout Payment',
  simulation_refund: 'Simulate Refund',
  customerService_manage: 'Customer Service',
  transaction_manage: 'Transactions',
  refund_transaction_query: 'Refund Search',
  customerService_manage_query_pay: 'Payin Search',
  customerService_manage_query_payout: 'Payout Search',
  customer_service_ticket_list: 'Tickets',
  customer_service_manage_query_card_verification: 'Account Validation Search',
  develop_manage: 'Developer',
  application_manage_list: 'Application List',
  application_manage_detail: 'Setting',
  institute_plan_template: 'Channel Plan Template',
  user_list: 'User Management',
  role_list: 'Role Management',
  financial: 'Financials',
  financial_setting: 'Financial Settings',
  payin: 'Payin',
  payout: 'Payout',
  loan: 'Loan',
  repayment: 'Repayment',
  balance: 'Balance',
  account_balance: 'Account Balance',
  balance_details: 'Balance Details',
  top_up: 'Top Up',
  questionnaire: 'Compliance Questionnaire',
  deposits: 'Deposits',
  transaction_summary: 'Summary',
  send_payments: 'Send Payments',
  online_payment: 'Payment Links',
  online_payout: 'Small-value Payment',
  online_large_payout: 'Large-value Beneficiary',
  payout_payment: 'Payment',
  large_value_payment: 'Large-value Payment',
  payment_link: 'Payment Links',
  reference_detail: 'Reference Detail',
  link_transaction_detail: 'Link Transaction Detail',
  payout_approval: 'Payout Approval',
  payment_page: 'Payment Page',
  edit_payment_information: 'Edit Payment Information',
  checking_order: 'Page Transactions',
  link_information: 'Page List',
  create_mch_code: 'Merchant Code',
  qr_stand: 'QR Stand',
  qr_stand_list: 'QR Stand List',
  supplementary_info: 'Supplementary Info',
  va_collection: 'VA Collection',
  va_account: 'VA Account',
  va_collection_query: 'VA Transactions',
  merchant_list: 'Merchant List',
  merchants: 'Merchants',
  refund: 'Refund',
  notifications: 'Notifications',
  checkout: 'Checkout',
  orders: 'Orders',
  batch_payment_details: 'Batch Payment Details',
  fx_transactions: 'FX',
  fx_query: 'FX Rate',
  split_transaction: 'Split',
  card_verification_list: 'Account Validation',
  service_provider_tools: 'Service Provider Tools',
  transaction_records: 'Transaction Records',
  static_qr: 'Static QR',
  accept_payments: 'Accept Payments',
  operation_manage: 'Operations',
  business_manage: 'Business Management',
  franchisee_manage: 'Franchisee Management',
  franchisee_create: 'Create Franchisee',
  franchisee_edit: 'Edit Franchisee',
  franchisee_detail: 'Franchisee Details'
}
